export const HEADERS = [
  'HEADER.ID',
  'HEADER.NAME',
  'HEADER.ICON',
  'HEADER.CREATED',
];
